import React, { useState } from 'react';
import styles from './ContainerCards.module.css';
import Card from './Card';
import imgResultadoOk from '../../Assets/resultadoCard.svg';
import imgAguardando from '../../Assets/aguardandoResult.svg';
import exame from '../../Assets/exame.svg';
import receita from '../../Assets/receita.svg';
import relatorio from '../../Assets/relatorio.svg';
import prontuario from '../../Assets/prontuario2.svg';
import atestado from '../../Assets/atestado.svg';
import { ReactComponent as Refresh } from '../../Assets/refresh.svg';
import { UserContext } from '../../UserContext';
import { useLocation } from 'react-router-dom';

interface ContainerCardsProps {
  tipo: number;
  titulo: string;
}

const ContainerCards = ({ tipo, titulo }: ContainerCardsProps) => {
  const location = useLocation();
  const { clinica, clinicas, data, token, getUser, loading, handleRefresh } =
    React.useContext(UserContext);
  // Estado local para controlar a animação do botão de refresh
  const [isRefreshing, setIsRefreshing] = useState(false);
  // Função para lidar com o clique no botão de refresh
  const handleRefreshClick = async () => {
    setIsRefreshing(true); // Ativa a animação
    await handleRefresh(); // Chama a função handleRefresh do contexto
    setIsRefreshing(false); // Desativa a animação após a conclusão
  };

  // Filtra os resultados com base no tipo e na clínica selecionada
  let resultados: any =
    data.length > 0 && clinica !== undefined && location.pathname !== '/home'
      ? data
          .map((resultado: any) => {
            if (clinica?.id === resultado.id_cliente) {
              const regex = /(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}\.\d{3}Z/;
              const dataFormatada = resultado.data.replace(regex, '$3/$2/$1');
              return resultado.tipo === tipo
                ? { ...resultado, data: dataFormatada }
                : null;
            }
          })
          .filter(Boolean)
      : data.length > 0 &&
        clinica === undefined &&
        location.pathname !== '/home'
      ? data
          .map((resultado: any) => {
            const regex = /(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}\.\d{3}Z/;
            const dataFormatada = resultado.data.replace(regex, '$3/$2/$1');
            return resultado.tipo === tipo
              ? { ...resultado, data: dataFormatada }
              : null;
          })
          .filter(Boolean)
      : data.length > 0 &&
        clinica !== undefined &&
        location.pathname === '/home'
      ? data
          .map((resultado: any) => {
            if (clinica && clinica?.id === resultado.id_cliente) {
              const regex = /(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}\.\d{3}Z/;
              const dataFormatada = resultado.data.replace(regex, '$3/$2/$1');
              return { ...resultado, data: dataFormatada };
            }
          })
          .filter(Boolean)
      : data.length > 0
      ? data
          .map((resultado: any) => {
            const regex = /(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}\.\d{3}Z/;
            const dataFormatada = resultado.data.replace(regex, '$3/$2/$1');
            return { ...resultado, data: dataFormatada };
          })
          .filter(Boolean)
      : [];

  // Função para escolher a imagem com base no tipo de documento
  const escolherImagem = (img: number) => {
    switch (img) {
      case 1:
        return exame;
      case 2:
        return receita;
      case 3:
        return relatorio;
      case 4:
        return atestado;
      case 5:
        return imgResultadoOk;
      default:
        return exame;
    }
  };

  // Efeito para animação ao mudar de rota ou clínica
  React.useEffect(() => {
    const element = document.querySelector('.animeLeft') as HTMLElement;
    const element2 = document.querySelector('.animeLeft2') as HTMLElement;
    if (element && element2) {
      element.classList?.remove('animeLeft');
      element2.classList?.remove('animeLeft2');
      void element.offsetWidth;
      void element2.offsetWidth;
      element.classList?.add('animeLeft');
      element2.classList?.add('animeLeft2');
    }
    // console.log(resultados);
  }, [location.pathname, clinica]);

  return (
    <div className={`${styles.containerResultados} animeLeft`}>
      <div className={`${styles.containerTitulo}`}>
        <h1>
          {titulo
            ? clinica?.nome
              ? `${titulo} - ${clinica.nome}`
              : titulo
            : ' '}
        </h1>
        {/* Botão de refresh */}
        <Refresh
          className={isRefreshing ? styles.loading : styles.refresh} // Aplica a classe de loading se isRefreshing for true
          onClick={handleRefreshClick} // Associa a função handleRefreshClick ao clique do botão
        />
      </div>
      <span></span>
      <div className={`${styles.containerCards} animeLeft2`}>
        {resultados && resultados.length > 0 ? (
          resultados.map((resultado: any, index: any) => (
            <Card
              link={resultado?.link}
              key={index}
              procedimento={resultado?.procedimento}
              tipo={resultado?.tipo}
              aguardando={resultado?.aguardando_resultado}
              img={
                tipo === 0
                  ? resultado?.aguardando_resultado
                    ? imgAguardando
                    : imgResultadoOk
                  : escolherImagem(resultado.tipo)
              }
              data={resultado?.data}
              medico={resultado?.medico}
              descricao={resultado?.descricao}
            />
          ))
        ) : (
          <h1 className={`${styles.frase} animeLeft2`}>
            Nenhum documento encontrado{' '}
            {clinica ? 'para a clínica ' + clinica.nome : ''}
          </h1>
        )}
      </div>
    </div>
  );
};

export default ContainerCards;
